const CONTACTS = {
  cmsAgentSupportEmail: 'FFMProducer-Assister@cms.hhs.gov',
  ceCourseApprovalEmail: 'cindy.revas@healthsherpa.com',
  supportEmail: 'trainingsupport@healthsherpa.com',
  supportPhone: '(855) 952-6761',
}

export default CONTACTS
